import React, { useEffect, useState } from 'react'
import "./resource.css"
import AddMore from "../../../assets/Icons/addMore.png"
import Remove from "../../../assets/Icons/minus.png"
import { DPR_API } from '../../../services/apiCalls/dprApiCalls'
import { toast } from 'react-toastify'

export default function Material(props) {

    const [description,setDesciption]=useState([])
    const [activity,setActivity]=useState([])
    const [user, setUser] = useState("");
    const [material, setmaterial] = useState([ {
        "no_of_material": "",
            "material_description": "",
            "part_name": "",
            "total_quantity_to_be_supplied": "",
            "available_at_site": "",
            "pending": "",
            "rate": "",
            "Total_ammount": "",
            "Balance_ammount": "",
            "Activity": '',
            "Activity_id": ''
    },]);
    const addMoreMapnPower = (e) => {
        e.preventDefault()
        setmaterial([...material,  {
            "no_of_material": "",
            "material_description": "",
            "part_name": "",
            "total_quantity_to_be_supplied": "",
            "available_at_site": "",
            "pending": "",
            "rate": "",
            "Total_ammount": "",
            "Balance_ammount": "",
            "Activity": '',
            "Activity_id": ''
        },])
    }

    const RemoveMoreMapnPower = (index, e) => {
        e.preventDefault();
        const list = [...material];
        list.splice(index, 1);
        setmaterial(list)
    }

    const getDescription = async()=>{
        const des=await DPR_API.get_material_description();
        if(des && des.modules?.length){
            setDesciption(des.modules)
        }else{
            setDesciption([])
        }

    }

    useEffect(()=>{
        const user = localStorage.getItem("state");
        const userInfo = JSON.parse((user));
        setUser(userInfo);
    },[])

    const selectChange=(index,e,type)=>{
        const { name, value } = e.target;
        const list = [...material];
        list[index][name] = value;
        list[index]['wp_owner_id']=user.user.user_id;
        list[index]['subtask_id']=props.subId
        setmaterial(list);
     }
     const inputChange=(index,e,type)=>{
        const { name, value } = e.target;
        const list = [...material];
        list[index][name] =value;
        list[index]['wp_owner_id']=user.user.user_id;
        list[index]['subtask_id']=props.subId
        setmaterial(list);
     }

    const getActivity = async()=>{
        const des=await DPR_API.get_material_activity();
        if(des && des.Activity?.length){
            setActivity(des.Activity)
        }else{
            setActivity([])
        }
    }
    useEffect(()=>{
        getDescription();
        getActivity();
    },[])

    const onSubmit=async(e)=>{
        e.preventDefault();
        const create=await DPR_API.create_resource_material(material);
        if(create && create.status===201){
            toast.success(create?.message,{autoClose:2000});
            setTimeout(() => {
                props.closeM(false);
            }, 2500);
        }
     }

    return <React.Fragment>
        {material?.map((val, x) => <>
            <div className='row m-3'>  
                <div className='col-6'>
                    <label className='label-custom'>Number of material</label>
                    <input va onChange={(e)=>inputChange(x,e,"resourceName")} name='no_of_material' type='text' value={val?.no_of_material} className='form-control shadow-none' />
                </div>
                <div className='col-6'>
                    <label className='label-custom'>Material Description</label>
                    <select value={val?.material_description} onChange={(e)=>selectChange(x,e,"role")} name='material_description' className='filter-label' style={{ width: "100%", height: 31, border: "1px solid #e6e3e3", borderRadius: 4 }}>
                        <option>Select material description</option>
                        {description?.length?description.map(val=><option value={val.des_id}>
                            {val?.Description}
                        </option>):""}
                    </select>
                </div>
            </div>

            <div className='row m-3'>  
                <div className='col-6'>
                    <label className='label-custom'>Part Name</label>
                    <input value={val.part_name} onChange={(e)=>inputChange(x,e,"resourceName")} name='part_name' type='text' className='form-control shadow-none' />
                </div>
                <div className='col-6'>
                    <label className='label-custom'>Total quantity to be supplied</label>
                    <input value={val.total_quantity_to_be_supplied} onChange={(e)=>inputChange(x,e,"resourceName")} name='total_quantity_to_be_supplied' type='text' className='form-control shadow-none' />
                </div>
            </div>

            <div className='row m-3'>  
                <div className='col-6'>
                    <label className='label-custom'>Available at Site</label>
                    <input value={val.available_at_site} onChange={(e)=>inputChange(x,e,"resourceName")} name='available_at_site' type='text' className='form-control shadow-none' />
                </div>
                <div className='col-6'>
                    <label className='label-custom'>Pending</label>
                    <input value={val.pending} onChange={(e)=>inputChange(x,e,"resourceName")} name='pending' type='text' className='form-control shadow-none' />
                </div>
            </div>

            <div className='row m-3'>  
                <div className='col-6'>
                    <label className='label-custom'>Rate</label>
                    <input value={val.rate} onChange={(e)=>inputChange(x,e,"resourceName")} name='rate' type='text' className='form-control shadow-none' />
                </div>
                <div className='col-6'>
                    <label className='label-custom'>Total Amount</label>
                    <input value={val.Total_ammount} onChange={(e)=>inputChange(x,e,"resourceName")} name='Total_ammount' type='text' className='form-control shadow-none' />
                </div>
            </div>
            <div className='row m-3'>
                <div className='col-6'>
                    <label className='label-custom'>Balance Amount</label>
                    <input value={val.Balance_ammount} onChange={(e)=>inputChange(x,e,"resourceName")} name='Balance_ammount' type='text' className='form-control shadow-none' />
                </div>
                <div className='col-6'>
                    <label className='label-custom'>Activity</label>
                    <select value={val.Activity} onChange={(e)=>selectChange(x,e,"role")} name='Activity' className='filter-label' style={{ width: "100%", height: 31, border: "1px solid #e6e3e3", borderRadius: 4 }}>
                        <option>Select activity</option>
                        {activity?.length?activity.map(val=><option value={val.activity_id}>
                            {val?.activity_name}
                        </option>):""}
                    </select>
                </div>
            </div>
            <div className='row m-3'>
                <div className='col-6'>
                    <label className='label-custom'>Activity ID</label>
                    <input value={val.Activity_id} onChange={(e)=>inputChange(x,e,"resourceName")} name='Activity_id' type='text' className='form-control shadow-none' />
                </div>
            </div>

            <div className='row m-3'>
                {material?.length !== 1 && (<div className='d-flex justify-content-end' >
                    <button className='d-flex remove-more' onClick={(e) => RemoveMoreMapnPower(x, e)}>
                        <div><img src={Remove} width={20} height={20} style={{ background: "red", borderRadius: 40, padding: 4 }} /></div>
                        <div className='my-auto' style={{ color: "white", fontSize: 14, fontWeight: 500, marginLeft: 2 }}>Remove</div>
                    </button>
                </div>)}
            </div>
            <hr />
        </>)}
        <div className='row m-3'>
            <div className='d-flex justify-content-end' >
                <button className='d-flex add-more' onClick={addMoreMapnPower}>
                    <div><img src={AddMore} width={20} height={20} /></div>
                    <div className='my-auto' style={{ color: "rgba(0, 0, 0, 1)", fontSize: 14, fontWeight: 500, marginLeft: 2 }}>Add More</div>
                </button>
            </div>
        </div>
        <div className='row mt-2'>
            <div class="d-flex justify-content-center">
                <div style={{ margin: 10 }}>
                    <button onClick={onSubmit} className='btn btn-primary'>Submit</button>
                </div>
                <div style={{ margin: 10 }}>
                    <button className='btn btn-danger'>Cancel</button>
                </div>
            </div>
        </div>
    </React.Fragment>
}

